import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"../../packages/design-system/constants.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"INTER_FONT\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/opt/build/repo/workspaces/packages/app-shell/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderAuthRedirect"] */ "/opt/build/repo/workspaces/packages/app-shell/RenderAuthRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteChangeTracker"] */ "/opt/build/repo/workspaces/packages/app-shell/RouteChangeTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/workspaces/packages/components/FeedbackForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/workspaces/packages/components/MainLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/opt/build/repo/workspaces/packages/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/workspaces/packages/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/workspaces/packages/design-system/theme.css");
